import { Text, VStack } from '@chakra-ui/react';
import { PrimaryButton } from '@jurnee/common/src/components/primitives/buttons/PrimaryButton';
import { PayoutBeneficiaryJSON } from '@jurnee/common/src/entities/PayoutBeneficiary';
import { PayoutInformationDrawer } from 'drawers/PayoutInformationDrawer';
import { useTranslation } from 'react-i18next';

interface Props {
  onUpsert(payoutInformation: PayoutBeneficiaryJSON): void;
  payoutInfoDrawerOpen?: boolean;
}

export function AddPayoutInformation(props: Props) {
  const { t } = useTranslation('payoutInformation', { keyPrefix: 'addPayoutInfo' });

  return (
    <VStack w="100%" spacing={5} p={5} bg="white" border="1px solid" borderColor="gray.200" borderRadius={4}>
      <Text color="gray.400" whiteSpace="pre-line" textAlign="center">{t('description')}</Text>

      <PayoutInformationDrawer onUpsert={props.onUpsert} defaultIsOpen={props.payoutInfoDrawerOpen}>
        <PrimaryButton size="sm" colorScheme="black">
          { t('button') }
        </PrimaryButton>
      </PayoutInformationDrawer>
    </VStack>
  );
}